import { render, staticRenderFns } from "./professionals-section.vue?vue&type=template&id=c2e78d6e&scoped=true&"
import script from "./professionals-section.vue?vue&type=script&lang=ts&"
export * from "./professionals-section.vue?vue&type=script&lang=ts&"
import style0 from "./professionals-section.vue?vue&type=style&index=0&id=c2e78d6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e78d6e",
  null
  
)

export default component.exports